import { render } from "./CaracProduto.vue?vue&type=template&id=9b576750&scoped=true"
import script from "./CaracProduto.vue?vue&type=script&lang=js"
export * from "./CaracProduto.vue?vue&type=script&lang=js"

import "./CaracProduto.vue?vue&type=style&index=0&id=9b576750&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b576750"]])

export default __exports__